import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import {
  ArrowLeftIcon,
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  DocumentIcon,
  ExclamationIcon,
} from "@heroicons/react/outline";
import { PAYMENT_STATUS } from "../../../constants/jewellery.constant";

const PaymentDetails = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const { selectedPayment, loading } = useSelector(
    (state) => state.jewelleryPlan?.payments
  );
  const [showProof, setShowProof] = useState(false);

  const payment = selectedPayment || {
    _id: paymentId,
    paymentNumber: "PAY20240115ABC123",
    planId: { _id: "plan123", planNumber: "PLN20240101XYZ" },
    userId: { name: "John Doe", phoneNumber: "+91 98765 43210" },
    amountCollected: 5000,
    verifiedAmount: 5000,
    method: "UPI",
    dateCollected: new Date("2024-01-15"),
    externalRef: "UPI123456789",
    status: PAYMENT_STATUS.VERIFIED,
    enteredBy: { name: "Staff Member" },
    createdAt: new Date("2024-01-15T10:00:00"),
    updatedAt: new Date("2024-01-15T14:30:00"),
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case PAYMENT_STATUS.VERIFIED:
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-success-light text-success-dark">
            <CheckCircleIcon className="h-4 w-4 mr-1.5" />
            Verified
          </span>
        );
      case PAYMENT_STATUS.REJECTED:
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-danger-light text-danger-dark">
            <XCircleIcon className="h-4 w-4 mr-1.5" />
            Rejected
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-warning-light text-warning-dark">
            <ClockIcon className="h-4 w-4 mr-1.5" />
            Pending Review
          </span>
        );
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center text-sm text-neutral-dark hover:text-text"
        >
          <ArrowLeftIcon className="h-4 w-4 mr-1" />
          Back
        </button>
        <div className="mt-2 flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-bold text-text">Payment Details</h1>
            <p className="mt-1 text-sm text-neutral-dark">
              {payment.paymentNumber}
            </p>
          </div>
          <div>{getStatusBadge(payment.status)}</div>
        </div>
      </div>

      <div className="bg-background shadow rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-neutral-light">
          <h3 className="text-lg font-medium text-text">Payment Information</h3>
        </div>
        <div className="px-6 py-4">
          <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <dt className="text-sm font-medium text-neutral-dark">
                Amount Collected
              </dt>
              <dd className="mt-1 text-sm text-text">
                <span className="text-lg font-medium">
                  ₹{payment.amountCollected?.toLocaleString()}
                </span>
              </dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-neutral-dark">
                Payment Method
              </dt>
              <dd className="mt-1 text-sm text-text">{payment.method}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
